import React, { PropsWithChildren, createContext, useContext, useState } from 'react'
import { StealthexToken } from '../clients/Stealthex'

export interface IConvertProvider {
  fromToken?: StealthexToken
  setFromToken: (token?: StealthexToken) => void
  toToken?: StealthexToken
  setToToken: (token?: StealthexToken) => void
  amount?: string
  setAmount: (amount: string) => void
  toAmount?: string
  setToAmount: (toAmount: string) => void
}

export const ConvertContext = createContext<IConvertProvider>(null as any)

export const ConvertProvider = ({ children }: PropsWithChildren) => {
  const [toAmount, setToAmount] = useState<string>('')
  const [amount, setAmount] = useState<string>('')
  const [fromToken, setFromToken] = useState<StealthexToken>()
  const [toToken, setToToken] = useState<StealthexToken | undefined>(undefined)

  return (
    <ConvertContext.Provider
      value={{
        fromToken,
        setFromToken,
        toToken,
        setToToken,
        amount,
        setAmount,
        toAmount,
        setToAmount,
      }}
    >
      {children}
    </ConvertContext.Provider>
  )
}

export const useConvertContext = () => useContext(ConvertContext)
